import React, { useState } from 'react'
import { MdExpandMore, MdExpandLess } from "react-icons/md"
import { useAccordionToggle } from 'react-bootstrap';

export const IconInfo = ({
    eventKey,
    fontSize = '125%',
    marginTop = 0
}) => {
    const [iconState, setIconState] = useState(false);
    
    const decoratedOnClick = useAccordionToggle(eventKey, (click) => {
        setIconState(click)
    });
    

    return (
        <>
            {
                (iconState === false) ?
                    (
                        <MdExpandMore
                            style={{
                                cursor: "pointer",
                                marginTop,
                                fontSize,
                            }}
                            onClick={() => decoratedOnClick(true)}
                        />
                    ) :
                    (
                        <MdExpandLess
                            style={{
                                cursor: "pointer",
                                marginTop,
                                fontSize,
                            }}
                            onClick={() => decoratedOnClick(false)}
                        />
                    )
            }
        </>
    )
}